<!-- <div class="modal-dialog "> -->
<div class="dialog-title" (click)="clickclose()">
    <mat-dialog-actions>
        <span class="closebuttonspan" mat-dialog-close mat-icon-button aria-label="close dialog" (click)="clickclose()">
            <i class="closebutton fa-solid fa-circle-xmark" (click)="clickclose()"></i>

        </span>
    </mat-dialog-actions>
</div>

<mat-dialog-content class="mat-dialog-content modal-body">

    <div class=""><span class="excursionname">{{data.exursionitem.Title}}</span></div>
    <br>
    <img class="mapdisplay" src={{data.exursionitem.ImageUrl}} />
    <div class="actdesc" [innerHTML]="data.exursionitem.Description">

    </div>


</mat-dialog-content>

<!-- </div> -->